import { Box, Button, Card, Divider, TextLink, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { PropertyContent } from "./PropertyContent";
import { useCompletePagePropertyViewModel } from "./useCompletePagePropertyViewModel";

export const FinishIncompleteListings: FunctionComponent = () => {
    const {
        cmsData: {
            complete: {
                finishYourIncompleteListingsText,
                youHaveMoreListingsInProgressText,
                viewAllListingsText,
                completeAndPublishText,
            },
        },
    } = useStaticDataAtomValue();
    const { incompleteListings, shouldShowViewAllListingButton, viewAllListingButtonUrl } =
        useCompletePagePropertyViewModel();

    if (incompleteListings === null || incompleteListings.length === 0) return null;

    return (
        <Box mb="32" data-element-name="finish-incomplete-listings">
            <Card type="non-interactive" variant="outlined" p="24" data-element-name="complete-next-listing-section">
                <Box mb="24">
                    <Typography variant="heading-default" textColor="base.default">
                        {finishYourIncompleteListingsText}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle" mt="8">
                        {youHaveMoreListingsInProgressText}
                    </Typography>
                </Box>
                {incompleteListings.map((item) => (
                    <Box
                        key={`incomplete-p${item.id}`}
                        display="block"
                        justifyContent="space-between"
                        alignItems="center"
                        mb="24"
                        qM={{ display: "flex" }}
                    >
                        <PropertyContent {...item} />
                        <Box
                            flexShrink={0}
                            mt="16"
                            mb="24"
                            ms="0"
                            width="100%"
                            qM={{ mt: "0", mb: "0", ms: "16", width: "auto" }}
                        >
                            <Button
                                variant="label"
                                size="l"
                                hierarchy="primary"
                                label={completeAndPublishText}
                                width="parent-fit"
                                data-element-name="complete-publish"
                                data-property-id={item.id}
                                onClick={() => {
                                    window.location.href = item.onboardingUrl;
                                }}
                            />
                        </Box>
                        <Box display="block" qM={{ display: "none" }}>
                            <Divider direction="horizontal" />
                        </Box>
                    </Box>
                ))}
                {shouldShowViewAllListingButton && viewAllListingButtonUrl && (
                    <Box display="flex" justifyContent="center" qM={{ justifyContent: "start" }}>
                        <TextLink
                            label={viewAllListingsText}
                            textVariant="body-s-strong"
                            data-element-name="view-all-listings"
                            href={viewAllListingButtonUrl}
                        />
                    </Box>
                )}
            </Card>
        </Box>
    );
};
